import userInfo from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
const adminTypes = {
  BILLING: 'BILLING',
  TEAM: 'TEAM',
  MARKETABLE_CONTACTS_WRITE: 'MARKETABLE_CONTACTS_WRITE'
};
const scopesByAdminType = {
  [adminTypes.BILLING]: ['billing-write'],
  [adminTypes.TEAM]: ['hub-owner', 'hub-parcel-write'],
  [adminTypes.MARKETABLE_CONTACTS_WRITE]: ['marketable-contacts-write']
};
const getIsAdmin = (adminType = adminTypes.TEAM) => userInfo().then(({
  user
}) => scopesByAdminType[adminType].some(scope => user.scopes.includes(scope)));
export const useIsAdmin = (adminType = adminTypes.TEAM) => {
  const [isAdmin, setIsAdmin] = useState(null);
  useEffect(() => {
    getIsAdmin(adminType).then(setIsAdmin).catch(() => setIsAdmin(false));
  }, [adminType]);
  return isAdmin;
};